module.exports = __webpack_public_path__ + "img/sdg-circle.db296e06.png";